<template>
  <div class="mt-4">
    <div v-for="frm of listaFormulario" :key="frm.idClasificacionSistemica" style="line-height: 2.2;">
     <div class="d-flex align-items-center mt-4 tituloEnfermedad">
      <img v-if="frm.idClasificacionSistemica == 30" class="img_cabecera mr-2" src="@/assets/hc/datoscabecera.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 31" class="img_cabecera mr-2" src="@/assets/hc/cardiovascular.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 32" class="img_cabecera mr-2" src="@/assets/hc/respiratorio.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 33" class="img_cabecera mr-2" src="@/assets/hc/nervioso.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 34" class="img_cabecera mr-2" src="@/assets/hc/endocrino.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 35" class="img_cabecera mr-2" src="@/assets/hc/gastro.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 36" class="img_cabecera mr-2" src="@/assets/hc/cronico.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 37" class="img_cabecera mr-2" src="@/assets/hc/autoinmunes.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 38" class="img_cabecera mr-2" src="@/assets/hc/gine.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 39" class="img_cabecera mr-2" src="@/assets/hc/hematologico.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 40" class="img_cabecera mr-2" src="@/assets/hc/alergia.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 41" class="img_cabecera mr-2" src="@/assets/hc/habitos.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 42" class="img_cabecera mr-2" src="@/assets/hc/medicamentos.png" alt="">
      <img v-if="frm.idClasificacionSistemica == 44" class="img_cabecera mr-2" src="@/assets/hc/temporomandibular.png" alt="">
      <p
        style="
          text-align: left;
          color: #1757b8 !important;
          font-size: 1.1em;
          font-weight: 800;
          width: 100%;
        "
      >
        {{ frm.nombreClasificacion }}
      </p>
     </div>

        <b-row class="mt-2" sm="12" md="6" lg="4" xl="4">
          <b-col
            sm="12"
            md="6"
            lg="4"
            xl="4"
            v-for="item of frm.enfermedades"
            :key="item.idEnfermedadSistemica"
            style="margin-bottom: 2%; margin-top: 2%;"
          >
            <template
              v-if="
                item.tipoCampoHtml !== 'checkbox' &&
                item.tipoCampoHtml !== 'switch' &&
                item.tipoCampoHtml !== 'select' &&
                item.tipoCampoHtml !== 'number' &&
                item.tipoCampoHtml !== 'radio'
              "
            >
              <div class="d-flex">
                <p class="txt">
                  {{ item.descripcionEnfermedad }}
                </p>
                <validacion v-if="item.requerido" />
              </div>

              <b-form-input
                class="txt"
                v-if="item.requerido"
                :type="item.tipoCampoHtml"
                :minlength="item.minCaracteres"
                :maxlength="item.maxCaracteres"
                v-model="item.valor"
                :state="
                  !item.requerido || (item.valor != null && item.valor !== '')
                "
                :required="item.requerido"
                v-on:keypress="esLetra($event)"
              />

              <b-form-input
                v-else
                class="txt"
                :type="item.tipoCampoHtml"
                :minlength="item.minCaracteres"
                :maxlength="item.maxCaracteres"
                v-model="item.valor"
                v-on:keypress="esLetra($event)"
              />
              <p />
            </template>
            <div
              class="d-flex w-100 justify-content-between align-items-center"
              v-else-if="item.tipoCampoHtml === 'radio'"
              style="min-height: 4.1em;"
            >
            <div style="width: 85%;">
              <p class="text-left txt">{{ item.descripcionEnfermedad }}</p>
              <validacion v-if="item.requerido" />
            </div>
            <b-form-radio
              class="m-0 text-left txt"
              :name="`radio-${item.idEnfermedadSistemica}`"
              :value="true"
              v-model="item.valor"
              :unchecked-value="false"
              :state="!item.requerido"
            />
            </div>
            <template v-else-if="item.tipoCampoHtml === 'number'">
              <p class="txt">
                {{ item.descripcionEnfermedad }}
                <validacion v-if="item.requerido" />
              </p>
              <b-form-input
                class="txt"
                v-if="item.requerido"
                :type="item.tipoCampoHtml"
                :minlength="item.minCaracteres"
                :maxlength="item.maxCaracteres"
                v-model="item.valor"
                :state="
                  !item.requerido || (item.valor != null && item.valor !== '')
                "
                :required="item.requerido"
              />

              <b-form-input
                v-else
                :type="item.tipoCampoHtml"
                :minlength="item.minCaracteres"
                :maxlength="item.maxCaracteres"
                v-model="item.valor"
              />
              <p />
            </template>
            <div v-else-if="item.tipoCampoHtml === 'select'">
              <label class="txt">
                {{ item.descripcionEnfermedad }}
                <validacion v-if="item.requerido"
              /></label>
              <b-form-select
                v-if="item.requerido"
                :options="item.opcionesExtraEnfSistemica"
                v-model="item.valor"
                text-field="descripcion"
                value-field="idOpcionEnfermedadSistemica"
                :state="
                  !item.requerido || (item.valor != null && item.valor !== '')
                "
                :required="item.requerido"
              >
              </b-form-select>

              <b-form-select
                v-else
                :options="item.opcionesExtraEnfSistemica"
                v-model="item.valor"
                text-field="descripcion"
                value-field="idOpcionEnfermedadSistemica"
              >
              </b-form-select>
              <p />
            </div>

            <div
              class="d-flex w-100 justify-content-between"
              v-else-if="item.tipoCampoHtml === 'switch' && item.requerido"
            >
            <div class="d-flex">
                <p class="text-left txt">{{ item.descripcionEnfermedad }}</p>
                <validacion v-if="item.requerido" />
            </div>
              <b-form-checkbox
                class="w-75 m-0 text-left txt"
                name="item.descripcionEnfermedad"
                v-model="item.valor"
                switch
                :state="!item.requerido"
              >
                
              </b-form-checkbox>
            </div>

            <div
              class="d-flex w-100 justify-content-between"
              v-else-if="item.tipoCampoHtml === 'switch' && !item.requerido"
              style="padding-left: 0px !important; position: relative;"
            >
            <div class="d-flex">
              <p class="text-left txt w-100">{{ item.descripcionEnfermedad }}</p>
              <validacion v-if="item.requerido" />
            </div>
              <b-form-checkbox
                class="ml-0"
                style="margin-left: 0px !important; margin: 0px; padding: 0px; left: 0px;"
                name="item.descripcionEnfermedad"
                v-model="item.valor"
                switch
              >
              </b-form-checkbox>            
            </div>

            <div
              class="d-flex w-100 justify-content-start switch-container"
              v-else-if="item.requerido"
              style="background-color: pink; padding-left: 0px"
            >
              <b-form-checkbox
                class="ml-0"
                style="margin-left: 0px !important; margin: 0px; padding: 0px"
                name="item.descripcionEnfermedad"
                v-model="item.valor"
                :state="!item.requerido"
                :required="item.requerido"
              >
                <p class="text-left txt">{{ item.descripcionEnfermedad }}</p>
                <validacion v-if="item.requerido" />
              </b-form-checkbox>
            </div>

            <b-form-checkbox
              v-else
              class="w-75 m-0"
              name="item.descripcionEnfermedad"
              v-model="item.valor"
            >
              <p class="text-left txt">{{ item.descripcionEnfermedad }}</p>
              <validacion v-if="item.requerido" />
            </b-form-checkbox>
            <p />
          </b-col>
        </b-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    listaFormulario: Array,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {},
};
</script>
<style scoped>
p {
  margin: 0px;
}

@media (max-width: 767.98px) {
  .tituloEnfermedad{
    height: 6em;
  }
}

.txt {
  color: #0046a2 !important;
  font-weight: 600 !important;
  font-size: 0.9em !important;
}

.img_cabecera{
  width: 2em;
  height: 2em;
}
</style>
